// This file contains utility functions for speech recognition
// that are used by main.js

function initializeSpeechRecognition() {
  if ('webkitSpeechRecognition' in window) {
    return new webkitSpeechRecognition();
  } else if ('SpeechRecognition' in window) {
    return new SpeechRecognition();
  } else {
    console.error('Speech recognition not supported in this browser');
    return null;
  }
}

function configureSpeechRecognition(recognition, langSelect, onEndCallback, onResultCallback) {
  if (!recognition) {
    return;
  }

  recognition.lang = langSelect.value;
  recognition.continuous = true;
  recognition.interimResults = false;

  recognition.onend = onEndCallback;
  recognition.onresult = onResultCallback;

  console.log('Speech recognition configured');
}

// Export the functions to be used in main.js
const speechRecognitionUtils = {
  initializeSpeechRecognition,
  configureSpeechRecognition
};

// Make speechRecognitionUtils available globally
window.speechRecognitionUtils = speechRecognitionUtils;

// Also export as a module for use with import statements
export default speechRecognitionUtils;